import { useLocation } from 'react-router-dom';

const pageTransitionStyles = `
  @keyframes pageTransitionFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .page-transition-enter {
    animation: pageTransitionFadeIn 280ms ease-out;
  }
`;

/**
 * Wraps route content so that every navigation (login, signup, forgot-password, etc.)
 * fades in smoothly instead of an instant cut.
 */
const PageTransition = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  return (
    <>
      <style>{pageTransitionStyles}</style>
      <div key={location.pathname} className="page-transition-enter">
        {children}
      </div>
    </>
  );
};

export default PageTransition;
